import { render, staticRenderFns } from "./ViewTablets.vue?vue&type=template&id=a15edac0&scoped=true"
import script from "./ViewTablets.vue?vue&type=script&lang=js"
export * from "./ViewTablets.vue?vue&type=script&lang=js"
import style0 from "./ViewTablets.vue?vue&type=style&index=0&id=a15edac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15edac0",
  null
  
)

export default component.exports